// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU2_thecomp__hEph9"};